import request from './handler'

const list = () => request.get('banks')

export default {
  list
}
